import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Sidebar.css"; // Create a separate CSS file for styling
import { Dashboard, Group, Message, Settings, ExpandLess, ExpandMore } from "@mui/icons-material";
import { useAuthService } from "./modules/login/authentication";

interface SidebarSectionProps {
  to?: string;
  icon: React.ComponentType;
  text: string;
  children?: React.ReactNode;
  role?: string;
}

const SidebarSection = ({ to, icon: Icon, text, children, role }: SidebarSectionProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const authService = useAuthService();

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  return (role && !authService.getRoles().includes(role)) ? (<></>) : (

    <li className="sidebar-section">
      {to ? (
        <NavLink
          to={to}
          className="sidebar-item"
          style={{ height: "30px", display: "flex", alignItems: "center" }}
        >
          <span className="icon"><Icon /></span>
          <span className="text" style={{ paddingLeft: "8px" }}>{text}</span>
          {children && (isOpen ? <ExpandLess /> : <ExpandMore />)}
        </NavLink>
      ) : (
        <div
          className="sidebar-item"
          style={{ height: "30px", display: "flex", alignItems: "center", cursor: "pointer", paddingBottom: children ? "8px" : "0" }}
          onClick={children ? handleToggle : undefined}
        >
          <span className="icon"><Icon /></span>
          <span className="text" style={{ paddingLeft: "8px", paddingRight: "4px" }}>{text}</span>
          {children && (isOpen ? <ExpandLess /> : <ExpandMore />)}
        </div>
      )}
      {children && isOpen && <ul className="submenu">{children}</ul>}
    </li>
  );
};

interface SidebarLinkProps {
  to: string;
  text: string;
}

const SidebarLink = ({ to, text }: SidebarLinkProps) => (
  <li>
    <NavLink to={to} className={({ isActive }) => (isActive ? "active" : "")}>
      <div className="sidebar-item" style={{ paddingLeft: "32px", display: "flex", alignItems: "center" }}>
        <span className="text" style={{ fontSize: "14px" }}>{text}</span>
      </div>
    </NavLink>
  </li>
);

const Sidebar = () => {
  return (
    <aside className="sidebar">
      <nav>
        <ul>
          <SidebarSection to="/dashboard" icon={Dashboard} text="Dashboard" />
          <SidebarSection to="/messages" icon={Message} text="Messages" />
          <SidebarSection icon={Group} text="Audience">
            <SidebarLink to="/audience/recipients" text="Recipients" />
            <SidebarLink to="/audience/groups" text="Groups" />
          </SidebarSection>
          <SidebarSection icon={Settings} text="Admin" role="admin">
            <SidebarLink to="/admin/users" text="Users" />
            <SidebarLink to="/admin/app-downloads" text="App Downloads" />
            <SidebarLink to="/admin/settings" text="Settings" />
          </SidebarSection>
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
